import { Modal, Button } from "antd";
import SUCCESS from "../../assets/images/success.gif";
import "./style.scss";
import React from "react";
function SuccessModal(props: any) {
  return (
    <Modal visible={props.visible} onCancel={props.onCancel} footer={false} centered>
      <div className="SuccessModal-modal">
        <br />
        <img src={SUCCESS} className="SuccessModal-image1" />
        <div className="SuccessModal-modal-txt1">{props.title}</div>
        <div className="SuccessModal-modal-txt2">{props.body}</div>
        <br />
        <div>
          <Button type="primary" size="large" onClick={() => props.onButtonClick()}>
            {props.buttonText}
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export default SuccessModal;
